import {
  Component,
  DestroyRef,
  inject,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

interface Breadcrumb {
  label: string;
  url: string;
}

@Component({
  selector: 'breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit, OnChanges {
  private router: Router = inject(Router);
  private route: ActivatedRoute = inject(ActivatedRoute);
  private destroyRef: DestroyRef = inject(DestroyRef);

  @Input() protocolNumber?: string;
  breadcrumbs: Breadcrumb[] = [];

  ngOnInit(): void {
    this.router.events
      .pipe(
        filter((event) => event instanceof NavigationEnd),
        takeUntilDestroyed(this.destroyRef)
      )
      .subscribe(() => {
        this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
      });
    this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['protocolNumber'] && !changes['protocolNumber'].firstChange) {
      this.updateBreadcrumbs();
    }
  }

  private updateBreadcrumbs(): void {
    setTimeout(() => {
      this.breadcrumbs = this.buildBreadcrumbs(this.route.root);
    });
  }

  nav(url: string, e: Event): void {
    e.preventDefault();
    this.router.navigateByUrl(url || '/');
  }

  buildBreadcrumbs(route: ActivatedRoute, url = '', breadcrumbs: Breadcrumb[] = []): Breadcrumb[] {
    if (!breadcrumbs.length) {
      breadcrumbs.push({ label: 'Home', url: '/home' });
    }

    if (!route.snapshot) return breadcrumbs;

    const routeURL: string = route.snapshot.url.map((s) => s.path).join('/');
    if (routeURL) url += `/${routeURL}`;

    const label = route.snapshot.data?.['breadcrumb'];
    if (label) {
      const routeParams = route.snapshot.params || {};
      let finalLabel = label;

      if (finalLabel.includes('{{protocolNumber}}')) {
        finalLabel = finalLabel.replace('{{protocolNumber}}', this.protocolNumber?.trim() || '--');
      } else {
        for (const key of Object.keys(routeParams)) {
          finalLabel = finalLabel.replace(`{{${key}}}`, routeParams[key]);
        }
      }

      const parts = finalLabel.split(' / ');
      if (parts.length === 2 && parts[0] === 'My portfolio') {
        breadcrumbs.push({ label: parts[0], url: '/portfolio' });
        breadcrumbs.push({ label: parts[1], url });
      } else {
        for (const part of parts) {
          if (part && part !== 'Home') breadcrumbs.push({ label: part, url });
        }
      }
    }

    for (const child of route.children || []) this.buildBreadcrumbs(child, url, breadcrumbs);
    return breadcrumbs;
  }
}
